export default __webpack_public_path__ + "static/media/success_tick.b674df8d.svg";